import * as Sentry from '@sentry/vue'

import { useAuthStore } from '@/features/auth/useAuthStore.js'

import { isSuperAdmin, useIsSuperAdmin } from '../superAdmin/useIsSuperAdmin'

export function setActiveClubId(clubId) {
  Sentry.setTag('tenantId', clubId)

  // Get current URL and update query parameter
  const currentUrl = new URL(window.location.href)

  if (clubId) {
    currentUrl.searchParams.set('activeClubId', clubId)
  } else {
    currentUrl.searchParams.delete('activeClubId')
  }

  // Use history.replaceState to update URL without page reload
  window.history.replaceState({}, '', currentUrl.toString())
}

export function clearActiveClubId() {
  const currentUrl = new URL(window.location.href)
  currentUrl.searchParams.delete('activeClubId')
  window.history.replaceState({}, '', currentUrl.toString())
}

export function getActiveClubId() {
  const currentUrl = new URL(window.location.href)
  return currentUrl.searchParams.get('activeClubId')
}

export function useActiveClub() {
  const activeClubId = getActiveClubId()

  const allClubs = useAuthStore().allClubs

  const activeClub = allClubs.find(club => club.tenantId === activeClubId)

  const isSuperAdmin = useIsSuperAdmin()
  if (!activeClub) {
    if (isSuperAdmin) {
      console.log('[useActiveClub] Super admin, no club found actually')
      return { activeClub: '_ImpersonatedClub_', allClubs }
    }
  }

  return { activeClub, allClubs }
}

export function getIsImpersonation(myDetails) {
  const currentUrl = new URL(window.location.href)
  const activeClubId = currentUrl.searchParams.get('activeClubId')

  return isSuperAdmin(myDetails) && currentUrl.pathname.startsWith('/admin') && !!activeClubId
}

export function finishClubImpersonation() {
  clearActiveClubId()
}
